module.exports = __webpack_public_path__ + "img/6.5b00bdb0.png";